<template>
	<div class="container-fluid">
		<Clist :regresar="regresar"
			:Nombre="Titulo"
			@FiltrarC="Lista"
			:Filtro="Filtro"
			:isModal="EsModal"
			:pShowBtnAdd="false"
			:pConfigLoad="ConfigLoad"
			:isHistorialEquipo="true"
			:ShowPager="ShowPager"
			:ShowFilas="false"
			:ShowBusqueda="false">
			<template slot="DatosEquipo">
				<div class="col-lg-12 mb-1">
					<div class="row">
						<div class="col-lg-2">
							<div class="avatar-upload-histequipo">
								<div class="avatar-preview">
									<div id="imagePreview" :style="'background-image: url('+RutaLogo+Sucursal.Logo+');'" :src="RutaLogo+Sucursal.Logo">
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-3">
							<div class="row">
								<div class="col-lg-3 pr-0">
									<span class="titulosmonitoreo">Empresa: </span>
								</div>
								<div class="col-lg-9 pl-1">
									<span v-b-tooltip.hover.top :title="Sucursal.Nombre" class="text-info titulosmonitoreo">{{ $limitCharacters(Sucursal.Nombre,30) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 pr-0">
									<span class="titulosmonitoreo">Dirección: </span>
								</div>
								<div class="col-lg-9 pl-1">
									<span class="text-info titulosmonitoreo">{{ Sucursal.Direccion }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 pr-0">
									<span class="titulosmonitoreo">Email: </span>
								</div>
								<div class="col-lg-9 pl-1">
									<span v-b-tooltip.hover.top :title="Sucursal.Correo" class="text-info titulosmonitoreo">{{ $limitCharacters(Sucursal.Correo,30) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 pr-0">
									<span class="titulosmonitoreo">Ciudad: </span>
								</div>
								<div class="col-lg-9 pl-1">
									<span v-b-tooltip.hover.top :title="Sucursal.Ciudad" class="text-info titulosmonitoreo">{{ $limitCharacters(Sucursal.Ciudad,30) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 pr-0">
									<span class="titulosmonitoreo">Estado: </span>
								</div>
								<div class="col-lg-9 pl-1">
									<span v-b-tooltip.hover.top :title="Sucursal.Estado" class="text-info titulosmonitoreo">{{ $limitCharacters(Sucursal.Estado,30) }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Cotizado</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.Cotizado))}}</h2>
								<!-- <h3 class="text-center text-info bold">{{ValoresCard.VentaPorcen}} %</h3> -->
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Cotizado TYP</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.TotalOrdenCompra))}}</h2>
								<!-- <h3 class="text-center text-info bold">{{ValoresCard.VentaPorcen}} %</h3> -->
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Total Orden Compra</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.TotalOrdenCompra))}}</h2>
								<!-- <h3 class="text-center text-info bold">{{ValoresCard.VentaPorcen}} %</h3> -->
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Materiales</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.TotalMateriales))}}</h2>
								<!-- <h3 class="text-center text-info bold">{{ValoresCard.CostoOperativoPorcen}} %</h3> -->
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Equipos</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.TotalEquipos))}}</h2>
								<!-- <h3 class="text-center text-info bold">{{ValoresCard.CostoOperativoPorcen}} %</h3> -->
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Refacciones</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.TotalRefacciones))}}</h2>
								<!-- <h3 class="text-center text-info bold">{{ValoresCard.CostoOperativoPorcen}} %</h3> -->
							</div>
						</div>
					</div>
					<div class="row mb-2 mt-3">
						<div class="form-inline">
							<button @click="CambiarPestania('Propiedades')" type="button" :class="Botones.Propiedades ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Propiedades</button>
							<button @click="CambiarPestania('OrdenCompra')" type="button" :class="Botones.OrdenCompra ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Ordenes de Compra</button>
							<button @click="CambiarPestania('Materiales')" type="button" :class="Botones.Materiales ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Materiales</button>
							<button @click="CambiarPestania('Equipos')" type="button" :class="Botones.Equipos ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Equipos</button>
							<button @click="CambiarPestania('Refacciones')" type="button" :class="Botones.Refacciones ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Refacciones</button>
						</div>
					</div>
				</div>
			</template>
			<template v-if="Botones.Propiedades" slot="header">
				<tr>
					<th>Nombre</th>
					<th>Dirección</th>
					<th>Email</th>
					<th>Teléfono</th>
				</tr>
			</template>
			<template v-if="Botones.Propiedades" slot="body">
				<tr v-for="(item,index) in ListaSucursales" :key="index">
					<td>{{item.NombrePublico}}</td>
					<td>{{item.DireccionPublico}}</td>
					<td>{{item.CorreoPublico}}</td>
					<td>{{item.TelefonoPublico}}</td>
				</tr>
			</template>

			<template v-if="Botones.OrdenCompra" slot="header">
				<tr>
					<th>Folio</th>
					<th>Solicitante</th>
					<th>Teléfono</th>
					<th>Email</th>
					<th>Fecha</th>
					<th>Vendedor</th>
					<th>Total</th>
					<th>Acciones</th>
				</tr>
			</template>
			<template v-if="Botones.OrdenCompra" slot="body">
				<tr v-for="(item,index) in ListaOrdenesCompra" :key="index">
					<td>{{item.Folio}}</td>
					<td>{{item.Solicitante}}</td>
					<td>{{item.Telefono}}</td>
					<td>{{item.Candado}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaCotiServicio,false)}}</td>
					<td>{{item.Vendedor}}</td>
					<td>${{item.ValorVenta}}</td>
					<td>
						<button v-b-tooltip.hover.lefttop  title="Orden Compra" @click="DescargarDistribuidor(item.IdCotizacionServicio,item.IdEmpresa,item.IdSucursal)"  type="button" class="btn-icon btn-pink mr-2">   <i class="fas fa-file-pdf"></i> </button>
					</td>
				</tr>
			</template>

			<template v-if="Botones.Materiales" slot="Filtros">
				<div class="form-group mr-2">
					<input type="text" class="form-control mr-2 ml-2 lup" placeholder="SKU" v-model="Filtro.Sku" @input="Filtrar">
				</div>
				<div class="form-group mr-2">
					<input type="text" class="form-control mr-2 ml-2 lup" placeholder="Item" v-model="Filtro.Item" @input="Filtrar">
				</div>
				<div class="form-group mr-2">
					<label for="">Proveedor</label>
				</div>
				<div class="form-group mr-2" style="max-width: 14rem">
					<treeselect
						@input="Lista();"
						:options="ListaProveedores"
						placeholder="Busque un Proveedor..."
						v-model="IdUsuario"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div style="width:55%" class="d-flex justify-content-end">
					<h1 class="naranja text-center">${{formateoMillon(parseFloat(TotalMateriales))}}</h1>
				</div>
			</template>
			<template v-if="Botones.Materiales" slot="header">		
				<tr>
					<th>Cotización</th>
					<th>Item</th>
					<th>Proveedor</th>
					<th>SKU</th>
					<th>Marca</th>
					<th>Modelo</th>
					<th>Cantidad</th>
					<th>Costo Unitario</th>
					<!-- <th>Total Individual</th> -->
				</tr>
			</template>
			<template v-if="Botones.Materiales" slot="body">
				<tr v-for="(item,index) in ListaMateriales" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaCotiServicio,false)}}</td>
					<td>{{item.Item}}</td>
					<td>{{item.Origen}}</td>
					<td>{{item.Codigo}}</td>
					<td>{{item.Marca}}</td>
					<td>{{item.Modelo}}</td>
					<td>{{item.Cantidad}}</td>
					<td>${{item.CostoUnitario}}</td>
					<!-- <td>${{item.TotalIndividual}}</td> -->
				</tr>
			</template>

			<template v-if="Botones.Equipos" slot="Filtros">
				<div class="form-group mr-2">
					<input type="text" class="form-control mr-2 ml-2 lup" placeholder="SKU" v-model="Filtro.Sku" @input="Filtrar">
				</div>
				<div class="form-group mr-2">
					<input type="text" class="form-control mr-2 ml-2 lup" placeholder="Item" v-model="Filtro.Item" @input="Filtrar">
				</div>
				<div class="form-group mr-2">
					<label for="">Proveedor</label>
				</div>
				<div class="form-group mr-2" style="max-width: 14rem">
					<treeselect
						@input="Lista();"
						:options="ListaProveedores"
						placeholder="Busque un Proveedor..."
						v-model="IdUsuario"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div style="width:55%" class="d-flex justify-content-end">
					<h1 class="naranja text-center">${{formateoMillon(parseFloat(TotalEquipos))}}</h1>
				</div>
			</template>
			<template v-if="Botones.Equipos" slot="header">		
				<tr>
					<th>Cotización</th>
					<th>Item</th>
					<th>Proveedor</th>
					<th>SKU</th>
					<th>Marca</th>
					<th>Modelo</th>
					<th>Cantidad</th>
					<th>Costo Unitario</th>
					<!-- <th>Total Individual</th> -->
				</tr>
			</template>
			<template v-if="Botones.Equipos" slot="body">
				<tr v-for="(item,index) in ListaEquipos" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaCotiServicio,false)}}</td>
					<td>{{item.Item}}</td>
					<td>{{item.Origen}}</td>
					<td>{{item.Codigo}}</td>
					<td>{{item.Marca}}</td>
					<td>{{item.Modelo}}</td>
					<td>{{item.Cantidad}}</td>
					<td>${{item.CostoUnitario}}</td>
					<!-- <td>${{item.TotalIndividual}}</td> -->
				</tr>
			</template>

			<template v-if="Botones.Refacciones" slot="Filtros">
				<div class="form-group mr-2">
					<input type="text" class="form-control mr-2 ml-2 lup" placeholder="SKU" v-model="Filtro.Sku" @input="Filtrar">
				</div>
				<div class="form-group mr-2">
					<input type="text" class="form-control mr-2 ml-2 lup" placeholder="Item" v-model="Filtro.Item" @input="Filtrar">
				</div>
				<div class="form-group mr-2">
					<label for="">Proveedor</label>
				</div>
				<div class="form-group mr-2" style="max-width: 14rem">
					<treeselect
						@input="Lista();"
						:options="ListaProveedores"
						placeholder="Busque un Proveedor..."
						v-model="IdUsuario"
						:disable-fuzzy-matching="true"
					/>
				</div>
				<div style="width:55%" class="d-flex justify-content-end">
					<h1 class="naranja text-center">${{formateoMillon(parseFloat(TotalRefacciones))}}</h1>
				</div>
			</template>
			<template v-if="Botones.Refacciones" slot="header">		
				<tr>
					<th>Cotización</th>
					<th>Item</th>
					<th>Proveedor</th>
					<th>SKU</th>
					<th>Marca</th>
					<th>Modelo</th>
					<th>Cantidad</th>
					<th>Costo Unitario</th>
					<!-- <th>Total Individual</th> -->
				</tr>
			</template>
			<template v-if="Botones.Refacciones" slot="body">
				<tr v-for="(item,index) in ListaRefacciones" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaCotiServicio,false)}}</td>
					<td>{{item.Item}}</td>
					<td>{{item.Origen}}</td>
					<td>{{item.Sku}}</td>
					<td>{{item.Marca}}</td>
					<td>{{item.Modelo}}</td>
					<td>{{item.Cantidad}}</td>
					<td>${{item.CostoUnitario}}</td>
					<!-- <td>${{item.TotalIndividual}}</td> -->
				</tr>
			</template>
		</Clist>
	</div>
</template>

<script>
import Clist from "@/components/Clist.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros";

export default {
	name: "ProyectoDesglose",
	props:["IdEmpresa","IdSucursal"],
	components:{
		Clist,Cbtnaccion
	},
	data() {
		return {
			regresar:true,
			Titulo:"Cliente",
			EsModal:true,
			ConfigLoad:{
				ShowLoader:false,
				ClassLoad:true
			},
			Filtro: {
				Nombre: "",
				Placeholder: "Nombre..",
				TotalItem: 0,
				Pagina: 1,
				Entrada: 16,
				Show:false,
				Sku:'',
				Item:''
			},
			ShowFiltro:false,
			Sucursal:{
				IdEmpresa:0,
				IdSucursal:0,
				Nombre:'',
				Telefono:'',
				DIreccion:'',
				Correo:'',
				Ciudad:'',
				Estado:'',
				CP:'',
				Logo:''
			},
			ListaSucursales:[],
			ListaOrdenesCompra:[],
			ListaMateriales:[],
			ListaEquipos:[],
			ListaRefacciones:[],
			ValoresCard:{
				Cotizado:0,
				CotizadoTyP:0,
				TotalOrdenCompra:0,
				TotalMateriales:0,
				TotalEquipos:0,
				TotalRefacciones:0
			},
			RutaLogo:"",
			Botones:{
				Propiedades:true,
				OrdenCompra:false,
				Materiales:false,
				Equipos:false,
				Refacciones:false,
			},
			ShowPager:true,
			TimeOut:null,
			TotalMateriales:0,
			TotalEquipos:0,
			TotalRefacciones:0,
			IdUsuario:null,
			ListaProveedores:[]
		}
	},
	methods: {
		async Lista(){
			this.Filtro.Show=false;
            this.ShowPager=true;
            this.ConfigLoad.ShowLoader=true;
			this.TotalMateriales=0;
			this.TotalEquipos=0;
			this.TotalRefacciones=0;
			if (this.Botones.Propiedades) {
				await this.$http.get('sucursal/get',{
					params:{
						IdEmpresa:this.Sucursal.IdEmpresa,
						RegEstatus:'A',
						Nombre:this.Filtro.Nombre,
                    	Entrada:this.Filtro.Entrada,
                    	pag:this.Filtro.Pagina
					}
				}).then((res) => {
					this.ListaSucursales=res.data.data.sucursal;
					this.Filtro.Entrada   = res.data.data.pagination.PageSize;
                	this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader = false;
				})
			}
			if (this.Botones.OrdenCompra) {
				// this.Filtro.Show=true;
				await this.$http.get('sucursalxdistribuidororden/get',{
					params:{
						IdSucursal:this.Sucursal.IdSucursal,
						RegEstatus:'A',
                    	Entrada:this.Filtro.Entrada,
                    	pag:this.Filtro.Pagina
					}
				}).then((res) => {
					this.ListaOrdenesCompra=res.data.data.ordenes;
					this.Filtro.Entrada   = res.data.data.pagination.PageSize;
                	this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader = false;
				})
			}
			if (this.Botones.Materiales) {
				this.Filtro.Show=true;
				await this.$http.get('sucursalxdistribuidormaterial/get',{
					params:{
						IdSucursal:this.Sucursal.IdSucursal,
						RegEstatus:'A',
						Codigo:this.Filtro.Sku,
						Item:this.Filtro.Item,
						IdUsuario:this.IdUsuario,
                    	Entrada:this.Filtro.Entrada,
                    	pag:this.Filtro.Pagina
					}
				}).then((res) => {
					this.ListaMateriales=res.data.data.materiales;
					this.TotalMateriales=res.data.data.total;
					this.Filtro.Entrada   = res.data.data.pagination.PageSize;
                	this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader = false;
				})
			}
			if (this.Botones.Equipos) {
				this.Filtro.Show=true;
				await this.$http.get('sucursalxdistribuidorequipo/get',{
					params:{
						IdSucursal:this.Sucursal.IdSucursal,
						RegEstatus:'A',
						Codigo:this.Filtro.Sku,
						Item:this.Filtro.Item,
						IdUsuario:this.IdUsuario,
                    	Entrada:this.Filtro.Entrada,
                    	pag:this.Filtro.Pagina
					}
				}).then((res) => {
					this.ListaEquipos=res.data.data.equipos;
					this.TotalEquipos=res.data.data.total;
					this.Filtro.Entrada   = res.data.data.pagination.PageSize;
                	this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader = false;
				})
			}
			if (this.Botones.Refacciones) {
				this.Filtro.Show=true;
				await this.$http.get('sucursalxdistribuidorrefaccion/get',{
					params:{
						IdSucursal:this.Sucursal.IdSucursal,
						RegEstatus:'A',
						Codigo:this.Filtro.Sku,
						Item:this.Filtro.Item,
						IdUsuario:this.IdUsuario,
                    	Entrada:this.Filtro.Entrada,
                    	pag:this.Filtro.Pagina
					}
				}).then((res) => {
					this.ListaRefacciones=res.data.data.refacciones;
					this.TotalRefacciones=res.data.data.total;
					this.Filtro.Entrada   = res.data.data.pagination.PageSize;
                	this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader = false;
				})
			}
		},
		async GetSucursal(){
			await this.$http.get('sucursalxdistribuidor/getcard',{
				params:{
					IdSucursal:this.Sucursal.IdSucursal
				}
			}).then((res)=>{
				this.Sucursal=res.data.data.sucursal;
				this.RutaLogo=res.data.data.ruta;
				this.ValoresCard.Cotizado=res.data.data.cotizado;
				this.ValoresCard.TotalOrdenCompra=res.data.data.totalordencompra;
				this.ValoresCard.TotalMateriales=res.data.data.montomaterial;
				this.ValoresCard.TotalEquipos=res.data.data.montoequipo;
				this.ValoresCard.TotalRefacciones=res.data.data.montorefaccion;
				this.Lista();
			}).finally(()=>{
				this.GetListaProveedores();
			})
		},
		CambiarPestania(index){
			this.Filtro.Sku='';
			this.Filtro.Item='';
			this.IdUsuario=null;
			let Botones=this.Botones;
			Object.keys(Botones).forEach(function(key,ind){
				if (key==index) {
					Botones[key]=true;
				}
				else{
					Botones[key]=false;
				}
				// console.log(index)
			});
			this.Lista();
		},
		Filtrar(){
			clearTimeout(this.TimeOut);
			this.TimeOut=setTimeout(()=>{
				this.Lista();
			},1000);
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
		DescargarDistribuidor(IdCotizacion,IdEmpresa,IdSucursal){
			this.$http.get('reporte/cotizaciondistribuidor',
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
						IdEmpresa:IdEmpresa,
						IdSucursal:IdSucursal,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
            });
		},
		async GetListaProveedores(){
			await this.$http.get('sucursalxdistribuidor/client',{
				params:{
					IdSucursal:this.Sucursal.IdSucursal
				}
			}).then((res)=>{
				this.ListaProveedores=res.data.data.todos.map((value) => {
					return {id:value.IdUsuario,label:value.Usuario}
				})
				this.ListaProveedores.push({id:0,label:'Otros'});
			})
		}
	},
	created() {
		if (this.IdEmpresa!=undefined) {
			sessionStorage.setItem("IdEmpresa",this.IdEmpresa);
		}
		if (this.IdSucursal!=undefined) {
			sessionStorage.setItem("IdSucursal",this.IdSucursal);
		}
		this.Sucursal.IdSucursal=sessionStorage.getItem("IdSucursal");
		this.Sucursal.IdEmpresa=sessionStorage.getItem("IdEmpresa");
		this.bus.$off('ListaPrincipal');
        this.bus.$on('ListaPrincipal',()=>{
            this.Lista();
        });
		this.bus.$off('List');
        this.bus.$on('List',()=>{
            this.GetSucursal();
        });
		this.bus.$off('Regresar');
		this.bus.$on('Regresar',()=>{
			this.$router.push({name:'distribuidorcliente'})
		})
	},
	mounted() {
		this.GetSucursal();
	}
}
</script>

<style>

</style>
